import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoggedInGuard } from "./_core/guards/logged-in/logged-in.guard";
import { SolicitudesUsersGuard } from "./_core/guards/solicitudes-users/solicitudes-users.guard";
import { RiegoUsersGuard } from "./_core/guards/riego-users/riego-users.guard";
import { ChatIaEnabledGuard } from "./_core/guards/chat-ia-enabled/chat-ia-enabled.guard";
import { ResetPassComponent } from "./_common/components/reset-pass/reset-pass.component";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./_common/app-common.module").then((m) => m.AppCommonModule),
  },
  {
    path: "solicitudes",
    canActivate: [LoggedInGuard, SolicitudesUsersGuard],
    loadChildren: () =>
      import("./_solicitudes/solicitudes.module").then(
        (m) => m.SolicitudesModule,
      ),
  },
  {
    path: "riego",
    canActivate: [LoggedInGuard, RiegoUsersGuard],
    loadChildren: () =>
      import("./_riego/riego.module").then((m) => m.RiegoModule),
  },
  {
    path: "configuracion",
    canActivate: [LoggedInGuard, SolicitudesUsersGuard],
    loadChildren: () =>
      import("./_configuracion/configuracion.module").then(
        (m) => m.ConfiguracionModule,
      ),
  },
  {
    path: "reset-pass/:Token/:Email",
    component: ResetPassComponent,
  },
  {
    path: "chat-ia",
    canActivate: [LoggedInGuard, ChatIaEnabledGuard],
    loadChildren: () =>
      import("./_riego/modules/chat-ia/chat-ia.module").then(
        (m) => m.ChatIaModule,
      ),
  },
  {
    path: "**",
    redirectTo: "login",
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class AppRoutingModule {}
